import { Autocomplete, Checkbox, FormControlLabel, TextField } from "@mui/material";

import { autoCompleteStyles } from "../../../../cm/Dashboard/FullPages/constant";
import FormField from "../../../../global/FormComponents/field/FormField";

const ProviderSection = ({
  toggleAddProvider,
  selectedCase,
  handleProvCheck,
  selectedProvider,
  providerList,
  handleProviderChange,
  setProviderSearch,
  disabled = false,
}) => (
  <>
    <FormControlLabel
      name="on_provider"
      label={<p>Involves a Medical Provider</p>}
      control={
        <Checkbox
          color="success"
          checked={toggleAddProvider && !!selectedCase}
          disabled={disabled || !selectedCase}
        />
      }
      onChange={() => {
        if (!selectedCase || disabled) {
          return;
        }
        handleProvCheck();
      }}
    />
    {(toggleAddProvider && (selectedCase || disabled)) && (
      <FormField label="Related Provider">
        <Autocomplete
          className="w-full"
          disablePortal
          options={providerList ?? []}
          getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          noOptionsText="No Results"
          sx={{
            width: 300,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          value={selectedProvider ?? null}
          onChange={(event, option) => handleProviderChange(option?.id ?? null)}
          disabled={disabled || !selectedCase}
          renderOption={(props, option) => (
            <li {...props} id={`${option.id}`} key={`${option.id}`}>
              {option?.label ?? option?.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              id="related-provider"
              required
              placeholder="Search provider"
              className="w-full"
              sx={{ ...autoCompleteStyles }}
              onChange={(event) => setProviderSearch?.(event.target.value)}
              onBlur={() => setProviderSearch?.("")}
            />
          )}
        />
      </FormField>
    )}
  </>
);

export default ProviderSection;
